/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { loadRubrics } from '@linc-technologies/linced-common/utils/rubrics';

export default class ReportingRoute extends Route {
  // Services
  @service
  dates;

  @service
  options;

  @service
  reportingGroupBrowser;

  @service
  session;

  @service
  store;

  @service
  students;

  model() {
    if (!this.options.value('hero:features:reporting')) {
      return {};
    }

    // Defer data needed by write/review views
    this.store.query('milestones/milestone-set', {
      include: 'milestones',
    });
    // Rubrics and rubric families are awaited alongside the rest, so write
    // and review views never resolve a rubric before they've loaded. A
    // failed load mustn't stop reporting opening, so it resolves empty.
    let jurisdiction = this.session.school && this.session.school.jurisdiction;
    let rubrics = jurisdiction
      ? loadRubrics(this.store, jurisdiction).catch(() => [])
      : [];
    let rubricFamilies = jurisdiction
      ? this.store
          .query('reports/rubric-family', { jurisdiction })
          .catch(() => [])
      : [];

    return hash({
      rubrics,
      rubricFamilies,
      groups: this.store.query('group', {
        schoolId: this.session.activeSchool,
        year: this.dates.currentAcademicYear,
      }),
      learners: this.students.all,
      reportTemplates: this.store.query('reports/report-template', {
        isActive: true,
        includeSections: true,
        schoolId: this.session.activeSchool,
      }),
    });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    if (!isEmpty(model.groups)) {
      this.reportingGroupBrowser.set('groups', model.groups);
    }
  }
}
